
import React from 'react';


const KristofferCarlsson = () => {
  return (
<div>
<a className="KristofferCarlsson-navbar-brand" href="/">Kristoffer Carlsson</a>


<div className="KristofferCarlsson-article-list-item" 
// itemscope="" itemprop="blogPost"
>
  
  <h3 className="KristofferCarlsson-article-title" 
  // itemprop="name"
  >
    <a href="http://kristofferc.github.io/post/intrinsics/" 
    // itemprop="url"
    >SIMD and SIMD-intrinsics in Julia</a>
  </h3>
  

  <div className="KristofferCarlsson-article-metadata">

    <span className="KristofferCarlsson-article-date">
      <time 
      // datetime="2018-11-13 15:00:00 +0000 UTC" itemprop="datePublished"
      >
        Tue, Nov 13, 2018
      </time>
    </span>

    <span className="KristofferCarlsson-article-tags">
      <i className="fa fa-tags"></i>
      
      <a className="KristofferCarlsson-article-tag-link" href="http://kristofferc.github.iotags/simd">simd</a>, 
      
      <a className="KristofferCarlsson-article-tag-link" href="http://kristofferc.github.iotags/intrinsics">intrinsics</a>, 
      
      <a className="KristofferCarlsson-article-tag-link" href="http://kristofferc.github.iotags/julia">julia</a>
      
    </span>
  </div>

  <div className="KristofferCarlsson-article-style" 
  // itemprop="articleBody"
  >
    <p>Short guide on SIMD and how to call (SIMD) intrinsics in the Julia programming language.</p>
  </div>
  
  <p className="read-more">
    <a href="http://kristofferc.github.io/post/intrinsics/" className="btn btn-primary btn-outline">
      CONTINUE READING
    </a>
  </p>
</div>



<div className="KristofferCarlsson-article-list-item">
  
  <h3 className="KristofferCarlsson-article-title">
    <a href="http://kristofferc.github.io/post/vectorization_performance_study/" className="KristofferCarlsson-article-link">
      Case study: Improving performance of a code written in Matlab style
    </a>
  </h3>
  

  <div className="KristofferCarlsson-article-metadata">

    <span className="KristofferCarlsson-article-date">
      <time>
        Mon, Dec 26, 2016
      </time>
    </span>

    <span className="KristofferCarlsson-article-tags">
      <i className="fa fa-tags"></i>
      
      <a className="KristofferCarlsson-article-tag-link" href="http://kristofferc.github.iotags/performance">performance</a>, 
      
      <a className="KristofferCarlsson-article-tag-link" href="http://kristofferc.github.iotags/vectorization">vectorization</a>, 
      
      <a className="KristofferCarlsson-article-tag-link" href="http://kristofferc.github.iotags/loops">loops</a>, 
      
      <a className="KristofferCarlsson-article-tag-link" href="http://kristofferc.github.iotags/julia">julia</a>
    </span>
  </div>

  <div className="KristofferCarlsson-article-style">
    <p>Analysis and optimization of a small code snippet posted on the Julia discourse mailing list.</p>
  </div>
  
  <p className="read-more">
    <a href="http://kristofferc.github.io/post/vectorization_performance_study/" className="btn btn-primary btn-outline">
      CONTINUE READING
    </a>
  </p>
</div>



</div>





);
};
export default KristofferCarlsson;